import { gql } from "@/services/httpAdapter";

export const onCreateSaleSpiffAward = gql`
	subscription onCreateSaleSpiffAward($locationId: String, $commissionCycleId: String) {
		onCreateSaleSpiffAward(locationId: $locationId, commissionCycleId: $commissionCycleId) {
			_id
			locationId
			commissionCycleId
			spiffSetup {
				_id
			}
			spiffItem {
				_id
			}
			recipient {
				_id
				fullName
			}
			awards {
				_id
				spiffEntry
				spiffDate
				spiffType
				deals {
					stockNumber
					dealNumber
				}
				reward
				createdAt
				updatedAt
			}
		}
	}
`;

export const onUpdateSaleSpiffAward = gql`
	subscription onUpdateSaleSpiffAward($locationId: String, $commissionCycleId: String) {
		onUpdateSaleSpiffAward(locationId: $locationId, commissionCycleId: $commissionCycleId) {
			_id
			locationId
			commissionCycleId
			spiffSetup {
				_id
			}
			spiffItem {
				_id
			}
			recipient {
				_id
				fullName
			}
			awards {
				_id
				spiffEntry
				spiffDate
				spiffType
				deals {
					stockNumber
					dealNumber
				}
				reward
				createdAt
				updatedAt
			}
		}
	}
`;

export const onDeleteSaleSpiffAward = gql`
	subscription onDeleteSaleSpiffAward($locationId: String, $commissionCycleId: String) {
		onDeleteSaleSpiffAward(locationId: $locationId, commissionCycleId: $commissionCycleId) {
			_id
			locationId
			commissionCycleId
			spiffSetup {
				_id
			}
			spiffItem {
				_id
			}
			awards {
				_id
			}
		}
	}
`;

export const onCreateServiceSpiffAward = gql`
	subscription onCreateServiceSpiffAward($locationId: String, $commissionCycleId: String) {
		onCreateServiceSpiffAward(locationId: $locationId, commissionCycleId: $commissionCycleId) {
			_id
			locationId
			commissionCycleId
			spiffSetup {
				_id
			}
			spiffItem {
				_id
			}
			recipient {
				_id
				fullName
			}
			awards {
				_id
				spiffEntry
				spiffDate
				spiffType
				repairOrders {
					vinNumber
					repairOrderNumber
				}
				reward
				createdAt
				updatedAt
			}
		}
	}
`;

export const onUpdateServiceSpiffAward = gql`
	subscription onUpdateServiceSpiffAward($locationId: String, $commissionCycleId: String) {
		onUpdateServiceSpiffAward(locationId: $locationId, commissionCycleId: $commissionCycleId) {
			_id
			locationId
			commissionCycleId
			spiffSetup {
				_id
			}
			spiffItem {
				_id
			}
			recipient {
				_id
				fullName
			}
			awards {
				_id
				spiffEntry
				spiffDate
				spiffType
				repairOrders {
					vinNumber
					repairOrderNumber
				}
				reward
				createdAt
				updatedAt
			}
		}
	}
`;

export const onDeleteServiceSpiffAward = gql`
	subscription onDeleteServiceSpiffAward($locationId: String, $commissionCycleId: String) {
		onDeleteServiceSpiffAward(locationId: $locationId, commissionCycleId: $commissionCycleId) {
			_id
			locationId
			commissionCycleId
			spiffSetup {
				_id
			}
			spiffItem {
				_id
			}
			awards {
				_id
			}
		}
	}
`;
